import React, { useState, useEffect } from 'react';

const SubscriptionCancel = () => {
  const [countdown, setCountdown] = useState(5); // init with num of seconds

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCountdown(prevCount => {
        if (prevCount <= 1) {
          clearInterval(intervalId);
          window.location.href = '/'; // Redirect to home screen
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const styles = {
    container: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 'min(600px, 90vw)',
      padding: '3rem 2rem', // Increased vertical padding
      boxSizing: 'border-box',
      borderRadius: '8px',
      backgroundColor: '#7986cb', // Light indigo background
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    card: {
      backgroundColor: '#fff',
      padding: '2rem',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      width: '90%',
      maxWidth: '400px',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2>Subscription Process Cancelled</h2>
        <p>Your subscription process was cancelled.</p>
        <p style={{ marginTop: '20px' }}>
          Redirecting to home screen in {countdown} seconds...
        </p>
      </div>
    </div>
  );
};

export default SubscriptionCancel;
